import {
  Button,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TableHead,
  Tooltip,
  Table,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  AdminTitleHolder,
  CustomDocumentLink,
} from "../../../common/sharedComponents/styles/card.style";
import {
  approveOrder,
  getInvoiceDetails,
  getLedgerDetails,
  getOrderDetails,
} from "../redux/userOrdersSlice";
import { styled as materialStyles } from "@mui/material/styles";
import Card from "@mui/material/Card";
import styled from "styled-components";
import { history } from "../../../app/history";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import InfoIcon from "@mui/icons-material/Info";
import { ApproveButton } from "../../vendorRegistration/components/ViewvendorDetails";
import {
  CustomTableContainer,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import moment from "moment";

function UserRefOrdersViewContent() {
  const { order_details, ledger_details, invoice_details } = useSelector(
    (state) => state.userOrders
  );
  const [open, setOpen] = React.useState(false);
  const params = useParams();
  const dispatch = useDispatch();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleApprove = (order_id) => {
    const payload = { order_id: order_id, accept_order: true };
    dispatch(approveOrder(payload)).then((response) => {
      setOpen(false);
      if (response.payload.success === true) {
        history.push("/app/user-orders-list");
      }
    });
  };

  const order_id = params.orderid;
  const apis = (order_id) => {
    dispatch(getOrderDetails(order_id));
    dispatch(getLedgerDetails(order_id));
    dispatch(getInvoiceDetails(order_id));
  };

  useEffect(() => {
    apis(order_id);
    // eslint-disable-next-line
  }, []);
  console.log("invoice_details", invoice_details);

  return (
    <>
      <AdminTitleHolder>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            Referenced Order#
            {order_details.order_number
              ? order_details.order_number
              : "Not Applicable"}
          </Grid>
          {order_details?.status !== "Accepted" ? (
            <Grid item xs={6}>
              <ApproveButton
                onClick={handleClickOpen}
                variant="outlined"
                style={{
                  height: "40px",
                  width: "150px",
                  float: "right",
                }}
              >
                Accept
              </ApproveButton>
            </Grid>
          ) : (
            <Grid item xs={6}>
              <Chip
                style={{
                  /*  height: "40px", */
                  width: "100px",
                  borderRadius: "25px",
                  backgroundColor: "var(--button-color)",
                  color: "white",
                  float: "right",
                }}
                label="Accepted"
              />
            </Grid>
          )}
        </Grid>
      </AdminTitleHolder>
      <StyledCard>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <Typography className="label"> COMPANY NAME</Typography>
              <VendorCardLabel>
                {order_details.CompanyName
                  ? order_details.CompanyName
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label"> TYPE</Typography>
              <VendorCardLabel>
                {order_details.type ? order_details.type : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">DEPARTMENT</Typography>
              <VendorCardLabel>
                {order_details.organizational_unit
                  ? order_details.organizational_unit
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">ORDER NUMBER</Typography>
              <VendorCardLabel>
                {order_details.order_number
                  ? order_details.order_number
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">AMOUNT</Typography>
              <VendorCardLabel>
                {order_details.order_amount
                  ? order_details.order_amount
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">PROJECT</Typography>
              <VendorCardLabel>
                {order_details.project
                  ? order_details.project
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">VERSION NUMBER</Typography>
              <VendorCardLabel>
                {order_details.version_number
                  ? order_details.version_number
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
          </Grid>
          <br />
          <br />
          <VendorCardTitle>Item Details</VendorCardTitle>
          <CustomTableContainer component={Card}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "#e1ebfa",
                  }}
                >
                  <TableCell width="10%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Sr. No.</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Item Name</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Quantity</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Unit Price</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Total Price</TableHeaderFont>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {order_details?.item_list ? (
                  order_details.item_list.map((row, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          width="10%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.item_name !== null
                            ? row.item_name
                            : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.quantity !== null
                            ? row.quantity
                            : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.unit_price !== null
                            ? row.unit_price
                            : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {parseFloat(row.quantity * row.unit_price).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow></TableRow>
                )}
              </TableBody>
            </Table>
          </CustomTableContainer>
          <br />
          <br />
          <VendorCardTitle>Ledger Details</VendorCardTitle>
          <CustomTableContainer component={Card}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "#e1ebfa" }}>
                  <TableCell width="10%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Sr. No.</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Invoice Number</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>UTR Number</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Payment Type</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Payment Amount</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Penalty</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>TDS</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>TAX</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Discrepancy</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>UTR Document</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Remarks</TableHeaderFont>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ledger_details && ledger_details.length > 0 ? (
                  ledger_details.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        width="10%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row?.Invoice?.invoice_number
                          ? row.Invoice.invoice_number
                          : "-"}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row?.utr_number ? row.utr_number : "-"}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row.payment_type !== null ? row.payment_type : "-"}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row.payment_amount !== null ? row.payment_amount : "-"}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row.PaymentSubTypes[0]?.payment_sub_type_amount
                          ? row.PaymentSubTypes[0].payment_sub_type_amount
                          : "-"}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row.PaymentSubTypes[1]?.payment_sub_type_amount
                          ? row.PaymentSubTypes[1].payment_sub_type_amount
                          : "-"}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row.PaymentSubTypes[2]?.payment_sub_type_amount
                          ? row.PaymentSubTypes[2].payment_sub_type_amount
                          : "-"}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row.PaymentSubTypes[3]?.payment_sub_type_amount
                          ? row.PaymentSubTypes[3].payment_sub_type_amount
                          : "-"}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{
                          fontFamily: "var(--font-family-reg)",
                          fontSize: "12px",
                          textAlign: "center",
                        }}
                      >
                        {row?.utr_document ? (
                          <Tooltip title="Download Document">
                            <CustomDocumentLink
                              href={row?.utr_document}
                              target="_blank"
                            >
                              <InsertDriveFileOutlinedIcon
                                style={{
                                  marginTop: "-1px",
                                  marginRight: "3px",
                                  height: "12px",
                                  width: "12px",
                                }}
                              />
                              {row?.utr_number} UTR Doc
                            </CustomDocumentLink>
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell
                        width="20%"
                        style={{ fontSize: "12px", textAlign: "center" }}
                      >
                        {row.remarks !== null ? row.remarks : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={9}
                      style={{
                        textAlign: "center",
                        padding: "16px",
                        fontSize: "14px",
                      }}
                    >
                      No records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </CustomTableContainer>
          <br />
          <br />
          <VendorCardTitle>Invoice Details</VendorCardTitle>
          <CustomTableContainer component={Card}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "#e1ebfa",
                  }}
                >
                  <TableCell width="10%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Sr. No.</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Invoice Number</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>invoice amount</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>invoice Creation Date</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Invoice Document</TableHeaderFont>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoice_details.length > 0 ? (
                  invoice_details.map((row, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          width="10%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.invoice_number ? row.invoice_number : "-"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.invoice_amount ? row.invoice_amount : "-"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.createdAt
                            ? moment(row.createdAt).format("DD MMM YY")
                            : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row?.Invoice_document?.invoice_document ? (
                            <Tooltip title="Download Document">
                              <CustomDocumentLink
                                href={row?.Invoice_document?.invoice_document}
                                target="_blank"
                              >
                                <InsertDriveFileOutlinedIcon
                                  style={{
                                    marginTop: "-1px",
                                    marginRight: "3px",
                                    height: "12px",
                                    width: "12px",
                                  }}
                                />
                                {row?.invoice_number} Invoice doc
                              </CustomDocumentLink>
                            </Tooltip>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      style={{
                        textAlign: "center",
                        padding: "16px",
                        fontSize: "14px",
                      }}
                    >
                      No invoice records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </CustomTableContainer>
          <br />
          <br />
          <VendorCardTitle>Documents</VendorCardTitle>
          <Grid container spacing={2}>
            <Grid item xs={6} md={4}>
              <Typography className="label">ORDER DOCUMENT</Typography>
              <VendorCardLabel>
                {order_details.Order_document ? (
                  order_details.Order_document ? (
                    <Tooltip title="Download Order Document">
                      <CustomDocumentLink
                        href={order_details.Order_document}
                        target="_blank"
                      >
                        <InsertDriveFileOutlinedIcon
                          style={{
                            marginTop: "-1px",
                            marginRight: "3px",
                            height: "12px",
                            width: "12px",
                          }}
                        />
                        Order document
                      </CustomDocumentLink>
                    </Tooltip>
                  ) : (
                    "Not Applicable"
                  )
                ) : (
                  "Not Applicable"
                )}
              </VendorCardLabel>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <Typography className="label">Supporting Documents</Typography>
              {order_details?.Supporting_document !== undefined &&
              order_details?.Supporting_document !== null &&
              order_details?.Supporting_document.length > 0 ? (
                order_details?.Supporting_document.map((item, index) => (
                  <VendorCardLabel key={index}>
                    <Tooltip title="Download Document">
                      <CustomDocumentLink href={item} target="_blank">
                        <InsertDriveFileOutlinedIcon
                          style={{
                            marginTop: "-1px",
                            marginRight: "3px",
                            height: "12px",
                            width: "12px",
                          }}
                        />
                        Supporting document
                      </CustomDocumentLink>
                    </Tooltip>
                  </VendorCardLabel>
                ))
              ) : (
                <Typography className="label">
                  <InfoIcon
                    sx={{
                      marginTop: "-1px",
                      marginRight: "1px",
                      fill: "grey",
                      height: "15px",
                      width: "15px",
                    }}
                  />{" "}
                  There are no supporting documents
                </Typography>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </StyledCard>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Please Confirm"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to accept this order?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              float: "right",
              backgroundColor: "var(--button-color)",
              color: "white",
            }}
            color="success"
            onClick={(e) => handleApprove(order_id)}
            autoFocus
            size="small"
          >
            Accept
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default UserRefOrdersViewContent;

export const StyledCard = materialStyles(Card)`
  box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
  flex-direction: column;
  border: none;
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 1em;
  `;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorCardTitle = styled.div`
  text-align: left;
  padding: 0px 20px 15px 0px;
  font-family: var(--font-family-semi-bold);
  font-weight: 600;
  font-size: 18px;
  color: #212134;
`;
